import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SiteAdvertsService } from '../../../core/services/data/site-adverts.service';
import { AnalyticsService } from '../../../core/services/analytics.service';
import { SitesService } from '../../../core/services/data/sites.service';
import { PurchaseProcessService } from '../../../core/services/data/purchase-process.service';
import { GenreService } from '../../../core/services/data/genre.service';

import { UserService } from '../../../core/services/data/user.service';
import { ModalService } from '../../../core/services/modal.service';

import { ISite, ISiteAdvert, IUser } from '../../../types/datatypes';
import { IPopulatedGenres } from '../../../types/populated';

@Component({
	selector: 'app-features-step3',
	templateUrl: './features-step3.component.html',
	styleUrls: ['./features-step3.component.scss'],
})
export class FeaturesStep3Component implements OnInit {
	public isFBAdCampaign = false;

	public userNotLogged = false;

	public hideButtonText = false;

	public user: IUser;

	public text = 'Early Access to Inventory is available to our Gold and Platinum Members';

	public availableTo;

	public subText = 'To access this promotion date you will need to upgrade to one of our paid membership plans.'
		+ ' You can learn more or upgrade using the link below.';

	public genres;

	private hasRun = false;

	constructor(
		private sas: SiteAdvertsService,
		private ss: SitesService,
		private as: AnalyticsService,
		private router: Router,
		private us: UserService,
		private ms: ModalService,
		private route: ActivatedRoute,
		private purchaseProcessService: PurchaseProcessService,
		private genreService: GenreService,
	) { }

	get siteSlug(): string | null {
		return this.purchaseProcessService.siteSlug;
	}

	get site(): ISite | null {
		return this.purchaseProcessService.site;
	}

	get siteAdvertSlug(): string | null {
		return this.purchaseProcessService.siteAdvertSlug;
	}

	get siteAdvert(): ISiteAdvert | null {
		return this.purchaseProcessService.siteAdvert;
	}

	get authorLink(): string {
		return this.purchaseProcessService.authorLink;
	}

	ngOnInit(): void {
		this.us.fetchUser().then((user: IUser) => {
			this.user = user;
		}, () => {
			this.text = 'Early Access to Inventory is available to our Gold and Platinum Members';
			this.hideButtonText = true;
		});

		this.genreService.getGenres().subscribe((genres: IPopulatedGenres[]) => {
			this.genres = genres;
		});

		this.initializeSiteAdvertAnalytics();
		this.resetScroll();

		document.addEventListener('click', this.handleDocumentClick.bind(this));
	}

	goToDashboard(event): void {
		this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
			this.router.navigate([`/author-dashboard/${this.authorLink}/home`]);
		});
	}

	refreshUser(): void {
		this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
			this.router.navigate([`/author-dashboard/${this.authorLink}/features/${this.siteSlug}/${this.siteAdvertSlug}`]);
		});
	}

	initializeSiteAdvertAnalytics() {
		if (!this.siteAdvert || !this.site) return;

		this.hasRun = false;

		const { siteAdvertSlug, siteAdvert, site } = this;
		const { price, parentGenre, name } = siteAdvert;

		const ecommerceItem = this.as.generateAnalyticsEcommerceObject(siteAdvertSlug, name, site.name, parentGenre, price);

		this.as.trackViewItem([ecommerceItem], this.siteSlug);
	}

	displayUnavailableToFreeModal() {
		this.ms.open('modal-promo');
	}

	upgrade(event) {
		const url = window.location.pathname;
		localStorage.setItem('url', url);
		if (event) {
			this.ms.open('update-card-form');
			return;
		}
		if (!this.user) {
			window.open('https://www.writtenwordmedia.com/membership/', '_blank');
			return;
		}

		this.router.navigate([`/author-dashboard/${this.user.authorLink}/subscriptions`]).then();
	}

	resetScroll() {
		window.scrollTo(0, 0);
	}

	handleDocumentClick(event: MouseEvent) {
		const target = event.target as HTMLElement;
		if (target.classList.contains('open-contact-form-modal')) {
			event.preventDefault();
			this.ms.open('contactFormModal');
		}
	}
}
